<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.role_claims.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3>{{ $t('pages.admin.role_claims.title') }}</h3>
        </div>
        <div class="n2-container">
            <div>
                <label>{{ $t('pages.admin.role_claims.role') }}: {{ entity.name }}</label>
            </div>
            <div v-if="claims.length > 0" class="n2-claims">
                <ul>
                    <li v-for="(entity, index) in claims" v-bind:key="entity.id">
                        <label class="n2-checkbox-lable">
                            <input type="checkbox" class="n2-checkbox-input" v-model="entity.selected"
                                v-on:change="selectClaim(entity, index)">
                            <span class="n2-checkbox-text">
                                {{ entity.claim_value }}
                            </span>
                        </label>
                        <ul>
                            <li v-for="child in entity.claims" v-bind:key="child.id">
                                <label class="n2-checkbox-lable">
                                    <input type="checkbox" class="n2-checkbox-input" v-model="child.selected"
                                        v-on:change="selectSubClaim(entity, index, child)">
                                    <span class="n2-checkbox-text">
                                        {{ child.claim_value }}
                                    </span>
                                </label>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div v-else class="title-default">
                {{ $t('shared.pager.no_record') }}
            </div>
            <validation-summary v-bind:errors="model_errors"></validation-summary>

            <div class="n2-form-group">
                <div class="n2-text-right">
                    <button v-on:click="save" class="n2-button-1">
                        {{ $t('pages.admin.role_claims.save') }}
                    </button>
                </div>
            </div>


        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { RoleService, ClaimService } from '../services';
import ValidationSummary from "../components/shared/validation-summary.vue";


export default {
    components: {
        ValidationSummary
    },
    props: {
    },
    data: function () {
        return {
            model_errors: {},
            id: '',
            languages: [],
            entity: {
            },
            claims: [],
        }
    },
    computed: {
        ...mapGetters('app_settings', [
            'company_id'
        ]),
        ...mapGetters('globalization', [
            'locale',
            'language'
        ]),

    },
    watch: {

    },
    created: function () {
        this.currentService = new RoleService();
        this.claimsService = new ClaimService();
    },
    mounted: async function () {
        const { id } = this.$route.params;
        if (id) {
            this.id = id;
            await this.loadEntity(id);
        }
    },
    methods: {
        loadEntity: async function (id) {
            let roleClaimsRes = await this.currentService.getClaims(id);
            let roleClaims = roleClaimsRes.data;
            console.log(roleClaims)
            let claimRes = await this.claimsService.search();
            console.log(claimRes)
            claimRes.data.forEach(c => {
                if (roleClaims.some(a => a.claim_id == c.id)) { c.selected = true; }
                c.claims.forEach(childClaim=>{
                    if (roleClaims.some(a => a.claim_id == childClaim.id)) { childClaim.selected = true; }
                })
            });
            this.claims = claimRes.data;

            this.entity = await this.currentService.find(id);

        },
        selectClaim: function (claim, index) {
            if (!claim.selected) {
                claim.claims.forEach(a => {
                    a.selected = false;
                })
            }
            else {
                claim.claims.forEach(a => {
                    a.selected = true;
                })
            }
            this.$set(this.claims, index, claim);
        },
        selectSubClaim: function (claim, index, childClaim) {
            if (childClaim.selected) {
                if (!claim.selected) {
                    claim.selected = true;
                }
            }
            if (!claim.claims.some(c => c.selected)) {
                claim.selected = false;
            }
            this.$set(this.claims, index, claim);
        },
        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },

        save: async function () {
            let roleClaims = this.claims.reduce((acc, cur) => {
                if (cur.selected) {
                    acc.push({ claim_id: cur.id });
                    acc = [...acc, ...cur.claims.filter(c => { return c.selected }).map(a => { return { claim_id: a.id } })];
                }
                return acc;
            }, []);
            roleClaims.forEach(rc => { rc.role_id = this.id });
            try {
                await this.currentService.saveClaims(this.entity.id, roleClaims);
                this.$router.go(-1);
            }
            catch (err) {
                if (err.response) {
                    this.model_errors = err.response.data;
                }
            }
        },

    },

}
</script>